import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "section-header" }, "Recent Videos", -1)
const _hoisted_3 = { class: "video-list grid grid-cols-3 sm-grid-cols-1 md-grid-cols-2 lg-grid-cols-2 xl-grid-cols-3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "video-title" }
const _hoisted_6 = { class: "video-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: video.id,
          to: { name: 'video-detail', params: { slug: video.slug }},
          class: "video-preview"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: video.thumbnail,
              alt: video.title
            }, null, 8, _hoisted_4),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(video.title), 1),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, _toDisplayString(video.publishedDate), 1),
              _createElementVNode("li", null, _toDisplayString(video.views) + " views", 1)
            ])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}